import * as PIXI from 'pixi.js';
import { ActionButton as UIActionButton } from '@orbital/slot-lib';
import { Tween, Easing } from '@tweenjs/tween.js';
import { mouseOverMixin } from './Button';

class ActionButton extends UIActionButton {
	constructor(obj) {
		super(obj, PIXI);
	}

	mouseUpHandler() {
		if (!this.enabled) return;

		if (this.tweenerUp) {
			this.tweenerUp.stop();
		}

		if (this.bg && (!this.tweenerUp || !this.tweenerUp.isPlaying())) {
			this.tweenerUp = new Tween(this.bg.scale)
				.to({ x: 1, y: 1 }, 50)
				.easing(Easing.Linear.None)
				.start();
		}
	}

	mouseDownHandler() {
		if (!this.enabled) return;

		if (this.bg && (!this.tweenerUp || !this.tweenerUp.isPlaying())) {
			this.tweenerUp = new Tween(this.bg.scale)
				.to({ x: 0.95, y: 0.95 }, 50)
				.easing(Easing.Linear.None)
				.start();
		}
	}
}

Object.assign(ActionButton.prototype, mouseOverMixin);

export default ActionButton;
